// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.three-d-modeling-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 120px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.three-d-modeling-image {
  position: relative;
  width: 35%;
  order: 1;
  padding: 10px 0;
  margin-top: 0;
}

.three-d-modeling-text {
  width: 60%;
  order: 2;
  margin-top: -75px;
}

.three-d-modeling-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.three-d-modeling-text h2 {
  font-size: 1.5em;
  color: #555;
  margin-top: 20px;
  margin-bottom: 10px;
}

.three-d-modeling-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.activities-list,
.services-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
  line-height: 1.8;
}

.activities-list li,
.services-list li {
  font-size: 0.95em;
  color: #333;
  margin-bottom: 10px;
}

.three-d-modeling-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.three-d-modeling-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .three-d-modeling-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .three-d-modeling-text {
    width: 220%;

    margin-left: 10px;
  }

  .three-d-modeling-image {
    margin-top: 20px;
    width: 220%;
  }
}

@media screen and (min-width: 1390px) and (max-width: 1919px) {
  .three-d-modeling-container {
    padding: 140px;
    gap: 15px;
  }

  .three-d-modeling-text h1 {
    font-size: 1.8em;
  }

  .three-d-modeling-text h2 {
    font-size: 1.4em;
  }

  .three-d-modeling-text p {
    font-size: 0.95em;
  }

  .three-d-modeling-image {
    width: 35%;
  }

  .three-d-modeling-button {
    padding: 8px 18px;
    font-size: 0.9em;
  }
}

@media screen and (min-width: 1920px) {
  .three-d-modeling-container {
    padding: 60px;
    gap: 25px;
  }

  .three-d-modeling-text h1 {
    font-size: 2.2em;
  }

  .three-d-modeling-text h2 {
    font-size: 1.6em;
  }

  .three-d-modeling-text p {
    font-size: 1.1em;
  }

  .three-d-modeling-image {
    width: 30%;
  }

  .three-d-modeling-button {
    padding: 12px 24px;
    font-size: 1.1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreeDModeling/ThreeDModeling.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;;IAEX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".three-d-modeling-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 120px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.three-d-modeling-image {\n  position: relative;\n  width: 35%;\n  order: 1;\n  padding: 10px 0;\n  margin-top: 0;\n}\n\n.three-d-modeling-text {\n  width: 60%;\n  order: 2;\n  margin-top: -75px;\n}\n\n.three-d-modeling-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.three-d-modeling-text h2 {\n  font-size: 1.5em;\n  color: #555;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.three-d-modeling-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.activities-list,\n.services-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px 0;\n  line-height: 1.8;\n}\n\n.activities-list li,\n.services-list li {\n  font-size: 0.95em;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.three-d-modeling-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.three-d-modeling-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .three-d-modeling-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .three-d-modeling-text {\n    width: 220%;\n\n    margin-left: 10px;\n  }\n\n  .three-d-modeling-image {\n    margin-top: 20px;\n    width: 220%;\n  }\n}\n\n@media screen and (min-width: 1390px) and (max-width: 1919px) {\n  .three-d-modeling-container {\n    padding: 140px;\n    gap: 15px;\n  }\n\n  .three-d-modeling-text h1 {\n    font-size: 1.8em;\n  }\n\n  .three-d-modeling-text h2 {\n    font-size: 1.4em;\n  }\n\n  .three-d-modeling-text p {\n    font-size: 0.95em;\n  }\n\n  .three-d-modeling-image {\n    width: 35%;\n  }\n\n  .three-d-modeling-button {\n    padding: 8px 18px;\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .three-d-modeling-container {\n    padding: 60px;\n    gap: 25px;\n  }\n\n  .three-d-modeling-text h1 {\n    font-size: 2.2em;\n  }\n\n  .three-d-modeling-text h2 {\n    font-size: 1.6em;\n  }\n\n  .three-d-modeling-text p {\n    font-size: 1.1em;\n  }\n\n  .three-d-modeling-image {\n    width: 30%;\n  }\n\n  .three-d-modeling-button {\n    padding: 12px 24px;\n    font-size: 1.1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
